import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

export const AddBrandApi = async (
  name,
  detail,
  profile,
  filekey,
  publicUrl,
  privateUrl,
  cdnUrl,
  otherUrl,
  user_id,
  token,
) => {
  try {
    //console.log("AddBrandApi");
    //console.log(names);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("detail", detail);
    formData.append("profile", profile);
    formData.append("file_key", filekey);
    formData.append("public_url", publicUrl);
    formData.append("private_url", privateUrl);
    formData.append("cdn_url", cdnUrl);
    formData.append("other_url", otherUrl);

    const response = await axios.post(`${BASE_URL}/brand/addBrand`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        user_id: user_id,
        token: token,
      },
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const AddCategoryApi = async (names, parent_id, user_id, token) => {
  try {
    //console.log("AddCategoryApi");
    //console.log(names);
    const response = await axios.post(
      `${BASE_URL}/category/addCategory`,
      {
        name: names,
        parent_id: parent_id,
      },
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const AddParentCategoryApi = async (
  name,
  note,
  featured,
  profile,
  filekey,
  publicUrl,
  privateUrl,
  cdnUrl,
  otherUrl,
  user_id,
  token,
) => {
  try {
    //console.log("AddCategoryApi");
    //console.log(names);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("note", note);
    formData.append("featured", featured);
    formData.append("profile", profile);
    formData.append("file_key", filekey);
    formData.append("public_url", publicUrl);
    formData.append("private_url", privateUrl);
    formData.append("cdn_url", cdnUrl);
    formData.append("other_url", otherUrl);

    const response = await axios.post(
      `${BASE_URL}/category/addParentCategory`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          user_id: user_id,
          token: token,
        },
      },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const AddUnitApi = async (
  names,
  parent_id,
  conv_rate,
  user_id,
  token,
) => {
  try {
    //console.log("AddUnit");
    //console.log(names);
    const response = await axios.post(
      `${BASE_URL}/unit/addUnit`,
      {
        name: names,
        parent_id: parent_id,
        conv: conv_rate,
      },
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const AddTagApi = async (names, parent_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/tag/addTag`,
      { name: names, parent_id: parent_id },
      { headers: { user_id: user_id, token: token } },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const AddParentTagApi = async (name, featured, rank, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/tag/addParentTag`,
      { name: name, rank: rank, featured: featured },
      { headers: { user_id: user_id, token: token } },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const EditBrandApi = async (
  brand_id,
  name,
  detail,
  profile,
  filekey,
  publicUrl,
  privateUrl,
  cdnUrl,
  otherUrl,
  user_id,
  token,
) => {
  try {
    //console.log("AddBrandApi");
    //console.log(names);
    const formData = new FormData();
    formData.append("brand_id", brand_id);
    formData.append("name", name);
    formData.append("detail", detail);
    formData.append("profile", profile);
    formData.append("file_key", filekey);
    formData.append("public_url", publicUrl);
    formData.append("private_url", privateUrl);
    formData.append("cdn_url", cdnUrl);
    formData.append("other_url", otherUrl);

    const response = await axios.put(`${BASE_URL}/brand/EditBrand`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        user_id: user_id,
        token: token,
      },
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const EditCategoryApi = async (
  category_id,
  names,
  parent_id,
  user_id,
  token,
) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/category/editCategory`,
      { category_id: category_id, name: names, parent_id: parent_id },
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const EditParentCategoryApi = async (
  category_p_id,
  name,
  note,
  featured,
  profile,
  filekey,
  publicUrl,
  privateUrl,
  cdnUrl,
  otherUrl,
  user_id,
  token,
) => {
  try {
    const formData = new FormData();
    formData.append("category_p_id", category_p_id);
    formData.append("name", name);
    formData.append("featured", featured);
    formData.append("note", note);
    formData.append("profile", profile);
    formData.append("file_key", filekey);
    formData.append("public_url", publicUrl);
    formData.append("private_url", privateUrl);
    formData.append("cdn_url", cdnUrl);
    formData.append("other_url", otherUrl);

    const response = await axios.put(
      `${BASE_URL}/category/EditParentCategory`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          user_id: user_id,
          token: token,
        },
      },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const EditTagApi = async (tag_id, names, parent_id, user_id, token) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/tag/EditTag`,
      { tag_id: tag_id, name: names, parent_id: parent_id },
      { headers: { user_id: user_id, token: token } },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const EditParentTagApi = async (
  tag_p_id,
  name,
  featured,
  rank,
  user_id,
  token,
) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/tag/EditParentTag`,
      { tag_p_id: tag_p_id, name: name, featured: featured, rank: rank },
      { headers: { user_id: user_id, token: token } },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const EditUnitApi = async (
  unit_id,
  names,
  parent_id,
  conv_rate,
  user_id,
  token,
) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/unit/EditUnit`,
      { unit_id: unit_id, name: names, parent_id: parent_id, conv: conv_rate },
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const DeleteBrandById = async (brand_id, user_id, token) => {
  try {
    //console.log("DeleteBrandById");
    //console.log(brand_id);
    const response = await axios.post(
      `${BASE_URL}/brand/deletebrandbyid`,
      { brand_id: brand_id },
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const DeleteCategoryById = async (category_id, user_id, token) => {
  try {
    //console.log("DeleteCategoryById");
    //console.log(category_id);
    const response = await axios.post(
      `${BASE_URL}/category/deletecategorybyid`,
      { category_id: category_id },
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const DeleteParentCategoryById = async (
  category_p_id,
  user_id,
  token,
) => {
  try {
    //console.log("DeleteCategoryById");
    //console.log(category_id);
    const response = await axios.post(
      `${BASE_URL}/category/deleteparentcategorybyid`,
      { category_p_id: category_p_id },
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const DeleteTagById = async (tag_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/tag/deletetagbyid`,
      { tag_id: tag_id },
      { headers: { user_id: user_id, token: token } },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const DeleteParentTagById = async (tag_p_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/tag/deleteparenttagbyid`,
      { tag_p_id: tag_p_id },
      { headers: { user_id: user_id, token: token } },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const DeleteUnitById = async (unit_id, user_id, token) => {
  try {
    //console.log("DeleteUnitById");
    const response = await axios.post(
      `${BASE_URL}/unit/deleteunitbyid`,
      { unit_id: unit_id },
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetBrandById = async (brand_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/brand/GetBrandById`,
      { brand_id: brand_id },
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetCategoryById = async (category_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/category/GetCategoryById`,
      { category_id: category_id },
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetParentCategoryById = async (category_p_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/category/GetParentCategoryById`,
      { category_p_id: category_p_id },
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetTagById = async (tag_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/tag/GetTagById`,
      { tag_id: tag_id },
      { headers: { user_id: user_id, token: token } },
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetParentTagById = async (tag_p_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/tag/GetParentTagById`,
      { tag_p_id: tag_p_id },
      { headers: { user_id: user_id, token: token } },
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetUnitById = async (unit_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/unit/GetUnitById`,
      { unit_id: unit_id },
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetUnitByProductId = async (product_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/unit/GetUnitByProductId`,
      { product_id: product_id },
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetAllBrands = async (user_id, token) => {
  try {
    //console.log("GetAllBrands");
    const response = await axios.post(
      `${BASE_URL}/brand/getallbrands`,
      {},
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetAllCategories = async (user_id, token) => {
  try {
    //console.log("GetAllCategories");
    const response = await axios.post(
      `${BASE_URL}/category/getallcategories`,
      {},
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetAllParentCategories = async (user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/category/getallparentcategories`,
      {},
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetAllUnits = async (user_id, token) => {
  try {
    //console.log("GetAllUnits");
    const response = await axios.post(
      `${BASE_URL}/unit/getallunits`,
      {},
      {
        headers: { user_id: user_id, token: token },
      },
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetAllTags = async (user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/tag/getalltags`,
      {},
      { headers: { user_id: user_id, token: token } },
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetAllParentTags = async (user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/tag/getallparenttags`,
      {},
      { headers: { user_id: user_id, token: token } },
    );
    return await response;
  } catch (err) {
    console.log(err);
    return err;
  }
};
